import { render, staticRenderFns } from "./ContentWorkshops.vue?vue&type=template&id=110d9ac4&"
import script from "./ContentWorkshops.vue?vue&type=script&lang=js&"
export * from "./ContentWorkshops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports